import { render, staticRenderFns } from "./GPlansTab.vue?vue&type=template&id=6dd4c6b7"
import script from "./GPlansTab.vue?vue&type=script&lang=js"
export * from "./GPlansTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports